import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientAPI } from "./axiosAnstance";
import axios from "axios";
import { SERVER_URL } from "../../../serverConfig";
import { getAuthHeader } from "../../../jwt/config";
import fileDownload from "js-file-download";

// --- THUNKS ---

// MODIFIÉ : Ajout de la pagination
export const listAidAdhaDemandeAPI = createAsyncThunk(
  "aid/listAidAdhaDemandeAPI",
  async ({ page = 0, size = 10 } = {}, thunkAPI) => {
    try {
      const url = `/api/adha/getDemandes?page=${page}&size=${size}`;
      const response = await clientAPI.get(url);
      console.log('liste demande :: ',response.data)
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// MODIFIÉ : Filtre avec pagination
export const listDemandeFilterAPI = createAsyncThunk(
  "adha/listDemandeFilterAPI",
  async (data, thunkAPI) => {
    try {
      // Extraction pagination
      const page = data.page || 0;
      const size = data.size || 10;

      // Séparation des filtres
      const filters = { ...data };
      delete filters.page;
      delete filters.size;


      const url = `/api/adha/filter?page=${page}&size=${size}`;
      const response = await clientAPI.post(url, filters);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const listAidDemandeTraiteAPI = createAsyncThunk(
  "adha/listAidDemandeTraiteAPI",
  async (data) => {
    const url = `/api/adha/listeDemandeTraite`;
    const response = await clientAPI.get(url);
    return response.data;
  }
);

export const traiteDemandeAidAPI = createAsyncThunk(
  "adha/traiteDemandeAidAPI",
  async ({ id }, thunkAPI) => {
    try {
      const url = `/api/adha/traiteDemande/${id}`;
      const response = await clientAPI.post(url);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const incompteteAidAPI = createAsyncThunk(
  "aid/incompteteAidAPI",
  async (data) => {
    const formData = new FormData();
    formData.append("idDemande", data.idDemande);
    formData.append("motifRefus", data.motifRefus);
    const response = await clientAPI.post("/api/adha/icompleteDemande", formData);
    return response.data;
  }
);

export const refuserAdhaAPI = createAsyncThunk(
  "adha/refuserAdhaAPI",
  async (data) => {
    const formData = new FormData();
    formData.append("idDemande", data.idDemande);
    formData.append("motifRefus", data.motifRefus);
    const response = await clientAPI.post("/api/adha/refusDemande", formData);
    return response.data;
  }
);

export const valideDemandeAPI = createAsyncThunk(
  "bourse/valideDemandeAPI",
  async ({ id, action }, thunkAPI) => {
    try {
      const url = `/api/adha/valide/${id}`;
      const response = await clientAPI.post(url);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const listTypeFichierSavedAidAPI = createAsyncThunk(
  "estivage/listTypeFichierSavedAidAPI",
  async (idDemande) => {
    const response = await clientAPI.get("/api/adha/listeTypeFichierSaved/" + idDemande);
    return response.data;
  }
);

export const getFileByDemandeAndTypeAid = createAsyncThunk(
  "adha/getFileByDemandeAndTypeAid",
  async (data) => {
    return axios
      .get(
        SERVER_URL +
        `/api/adha/getFileByDemandeAndType/${data.idDemande}/${data.id_type_fichier}`,
        {
          headers: getAuthHeader(),
          responseType: "blob",
        }
      )
      .then((res) => {
        return res.data;
      });
  }
);

// AJOUTÉ : Fonction d'exportation
export const downloadExportAidAdhaAPI = createAsyncThunk(
  "aid/exportData",
  async (data) => {
    const token = localStorage.getItem("token");
    const d = new Date();
    const datestring =
      ("0" + d.getDate()).slice(-2) + "-" +
      ("0" + (d.getMonth() + 1)).slice(-2) + "-" +
      d.getFullYear() + "_" +
      ("0" + d.getHours()).slice(-2) +
      ("0" + d.getMinutes()).slice(-2);

    const response = await axios.post(
      `${SERVER_URL}/api/adha/export-data`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        responseType: "blob",
      }
    );

    fileDownload(response.data, `Aid_Adha-${datestring}.xlsx`);
  }
);

// Note: J'ai laissé ce thunk car il était dans votre code original,
// mais il semble pointer vers /api/estivage. Vérifiez si c'est intentionnel.
export const saveFichierEstivageAPI = createAsyncThunk(
  "estivage/saveFichier",
  async (data) => {
    const fichi = JSON.stringify(data.toSave);
    const blob = new Blob([fichi], { type: "application/json" });
    var formData = new FormData();
    var theFile = data.file;

    formData.append("file", theFile);
    formData.append("fileMeta", blob);
    let token = localStorage.getItem("token");

    const response = axios.post(SERVER_URL + `/api/estivage/saveFichier`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      Accept: "application/json",
    });
    return (await response).data;
  }
);

// --- SLICE ---

const AidAdha = createSlice({
  name: "aidAdha",
  initialState: {
    listeDemande: [],
    listeDemandeTraite: [],
    listeTypeFichierSaved: [],
    // MODIFIÉ : Métadonnées de pagination
    totalElements: 0,
    pageNumber: 0,
    pageSize: 10,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // LISTE PAGINÉE
      .addCase(listAidAdhaDemandeAPI.pending, (state) => {
        state.status = "loading";
      })
      .addCase(listAidAdhaDemandeAPI.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.listeDemande = action.payload.content;
        state.totalElements = action.payload.totalElements;
        state.pageNumber = action.payload.number;
        state.pageSize = action.payload.size;
      })
      .addCase(listAidAdhaDemandeAPI.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // FILTRE PAGINÉ
      .addCase(listDemandeFilterAPI.pending, (state) => {
        state.status = "loading";
      })
      .addCase(listDemandeFilterAPI.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.listeDemande = action.payload.content;
        state.totalElements = action.payload.totalElements;
        state.pageNumber = action.payload.number;
        state.pageSize = action.payload.size;
      })
      .addCase(listDemandeFilterAPI.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // AUTRES
      .addCase(listTypeFichierSavedAidAPI.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.listeTypeFichierSaved = action.payload;
        console.log('liste fichier saved :: ',action.payload)
      })
      .addCase(listAidDemandeTraiteAPI.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.listeDemandeTraite = action.payload;
      });
  },
});

export const {} = AidAdha.actions;

export default AidAdha.reducer;
